/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import './LoadingRendererStyles.scss';
const baseClass = 'qmb-ui-LoadingRenderer';
export function LoadingRenderer({ block }) {
    const loading = block;
    return (React.createElement("div", { className: `${baseClass} ${baseClass}--${loading.phase}` },
        React.createElement("i", { className: "fa-light fa-spinner-third fa-spin" }),
        React.createElement(Text, { variant: "body" }, loading.message)));
}
